import React from "react";
import { useArticleHierarchy } from "../utils/article-hierarchy";
import { CardList } from "./blocks/card-list";

export interface Article {
  readonly id: string;
  readonly Page_title: string | null;
  readonly slug: string | null;
  readonly Page_basics: {
    readonly Page_media: {
      readonly ThumbnailImage: {
        readonly localFile: any;
      } | null;
    } | null;
    summary: string | null;
    introduction: {
      readonly data: {
        readonly childrenMarkdownRemark: ReadonlyArray<{
          readonly html: string | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
  readonly Event_info: {
    Start_date: string | null;
  } | null;
  readonly keywords: ReadonlyArray<{
    readonly keyword: string | null;
  } | null> | null;
  readonly article_type: {
    name: string | null;
  } | null;
}

export const ArticleCardList: React.FC<{
  articles: Article[] | null;
  title?: string;
  textBlock?: {
    readonly data: {
      readonly text_block: string;
    } | null;
  } | null;
  showTitleAndDivide?: boolean;
}> = ({ articles, title, textBlock, showTitleAndDivide }) => {
  const { getAncestorsForArticleId } = useArticleHierarchy();
  if (!articles) return null;
  return (
    <CardList
      title={title}
      textBlock={textBlock}
      showDividerAndTitle={showTitleAndDivide}
      items={articles.map((article) => {
        if (!article) return null;
        const ancestors = getAncestorsForArticleId(article.id);
        const subCategory =
          ancestors.length > 1
            ? ancestors[ancestors.length - 1].type === "subCategory"
              ? ancestors[ancestors.length - 1]
              : null
            : null;
        const highlighted = false;
        const eventDate = article.Event_info
          ? article.Event_info.Start_date
          : null;
        const summary = article.Page_basics
          ? article.Page_basics.summary
          : null;
        const labelOverride = null;
        return {
          id: article.id,
          title: article.Page_title,
          url: `/article/${article.slug}`,
          image: article.Page_basics?.Page_media?.ThumbnailImage
            ? (article.Page_basics?.Page_media?.ThumbnailImage
                .localFile as ImageDataLikeWithPropsForGifs | null)
            : null,
          label: eventDate,
          labelRight: article.article_type ? article.article_type.name : null,
          highlighted,
          external: false,
          border: true,
          labelOverride,
          keywords: article.keywords
            ? article.keywords.map((keyword) =>
                keyword ? keyword.keyword : null,
              )
            : null,
          summary,
        };
      })}
    />
  );
};
